import { fetchHostExperiencesPaginated } from 'flux/clients/experiences';
import Experience from 'model/IExperience';
import { useEffect, useState } from 'react';
import { useCurrencyContext } from '~/context/CurrencyContext';

type ReturnType = {
  data: Experience[];
  isLoading: boolean;
  error: any;
};

const initState: ReturnType = {
  data: [],
  isLoading: true,
  error: null,
};

function useHostExperiences(prettyUrl): ReturnType {
  const { state: currencyState } = useCurrencyContext();
  const [state, setState] = useState<ReturnType>(initState);

  useEffect(() => {
    fetchHostExperiencesPaginated(prettyUrl, currencyState.currency)
      .then((result) =>
        setState({ data: result, isLoading: false, error: null }),
      )
      .catch((error) => setState({ data: [], isLoading: false, error }));
  }, [prettyUrl, currencyState.currency]);

  return state;
}

export default useHostExperiences;
